"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../controllers/BaseController");
var DlgYesNoCtl = /** @class */ (function (_super) {
    __extends(DlgYesNoCtl, _super);
    function DlgYesNoCtl() {
        return _super.call(this, true) || this;
    }
    DlgYesNoCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            onNo: null,
            visible: false,
            title: "",
            message: ""
        };
    };
    DlgYesNoCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgYesNoCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgYesNoCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgYesNoCtl.prototype.SetTitle = function (val) {
        this.DATA.title = val;
        this.Update();
        return this;
    };
    DlgYesNoCtl.prototype.SetMessage = function (val) {
        this.DATA.message = val;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgYesNoCtl.prototype, "OnYes", {
        get: function () {
            return this.DATA.onYes;
        },
        enumerable: true,
        configurable: true
    });
    DlgYesNoCtl.prototype.SetOnYesClick = function (callback) {
        this.DATA.onYes = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgYesNoCtl.prototype, "OnNo", {
        get: function () {
            return this.DATA.onNo;
        },
        enumerable: true,
        configurable: true
    });
    DlgYesNoCtl.prototype.SetOnNoClick = function (callback) {
        this.DATA.onNo = callback;
        this.Update();
        return this;
    };
    return DlgYesNoCtl;
}(BaseController_1.BaseController));
exports.DlgYesNoCtl = DlgYesNoCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgYesNoCtl.ts
// module id = 892
// module chunks = 0